import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { HotkeysService } from 'src/app/services/hotkeys.service';

export interface DialogData {
  text: string;
  title?: string;
  okText: string;
  cancelText: string;
  labelRequired: boolean;
  label?: string;
}

@Component({
    selector: 'app-bookmarks-label-dialog',
    templateUrl: './bookmarks-label-dialog.component.html',
    standalone: false
})
export class BookmarksLabelDialogComponent extends UnsubscriberComponent implements OnInit {

  public labelForm: UntypedFormGroup;

  constructor(
    private dialogRef: MatDialogRef<BookmarksLabelDialogComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private hotkeys: HotkeysService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.labelForm = this.fb.group({
      label: [this.data.label],
    });

    if (this.data.labelRequired) {
      this.labelForm.get('label').setValidators(Validators.required);
    }

    this.subscriptions.add(
      this.hotkeys.addShortcut({ keys: 'y' }).subscribe(() => {
        this.dialogRef.close(true);
      })
    );
    this.subscriptions.add(
      this.hotkeys.addShortcut({ keys: 'n' }).subscribe(() => {
        this.dialogRef.close(false);
      })
    );
  }

  get labelData() {
    return this.labelForm.get('label').value;
  }

}
